<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>credit_card</mat-icon></div>
    <div class="pcd-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cancel()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando tarjeta…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Guardando tarjeta…' : 'Creando tarjeta…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch">
        <mat-icon>error</mat-icon>
        <span>{{ loadError }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <form class="pcd-form" [formGroup]="form" (ngSubmit)="save()" novalidate>
      <div class="cf-dlg-body">
        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <span class="cf-dlg-section__label">Tarjeta</span>

        <div class="cf-field--required" [class.cf-field--invalid]="hasError('name', 'required')">
          <app-field [control]="form.controls.name" [config]="nameConfig"></app-field>
        </div>

        <div class="pcd-row">
          <div class="cf-field--required" [class.cf-field--invalid]="hasError('number', 'required')">
            <app-field [control]="form.controls.number" [config]="numberConfig"></app-field>
          </div>

          <div [class.cf-field--invalid]="hasError('expiring', 'expiry')">
            <app-field [control]="form.controls.expiring" [config]="expiringConfig"></app-field>
          </div>
        </div>

        <span class="cf-dlg-section__label">Cuenta bancaria asociada</span>

        <div class="cf-field--required" [class.cf-field--invalid]="hasError('bankAccount', 'option')">
          <app-autocomplete [control]="form.controls.bankAccount" [config]="bankAccountConfig"></app-autocomplete>
        </div>

        <div class="pcd-uid" *ngIf="entity?.uid">
          <button type="button" class="pcd-link" (click)="showUid = !showUid">
            <mat-icon>{{ showUid ? 'visibility_off' : 'visibility' }}</mat-icon>
            {{ showUid ? 'Ocultar UID' : 'Ver UID' }}
          </button>
          <span class="pcd-uid__value" *ngIf="showUid">{{ entity?.uid }}</span>
        </div>
      </div>

      <div class="cf-dlg-footer">
        <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
        <button type="submit" mat-flat-button class="cf-dlg-btn-primary" [disabled]="saving">
          <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear tarjeta' }}
        </button>
      </div>
    </form>
  </ng-container>
</div>
